import { createBrowserRouter, Navigate } from 'react-router';
import Layout from '@Pages/layout';
import { PATHS } from '@Constants/paths.constants';
import ProfilePage from '@Pages/profile';
import SchedulingPage from '@Pages/scheduling';
import DocumentationPage from '@Pages/documentation';
import PassportPage from '@Pages/documentation/passport';
import VisaPage from '@Pages/documentation/visa';
import PickupPage from '@Pages/documentation/pickup';
import WorkPermitPage from '@Pages/documentation/work-permit';
import MedicalCertificatePage from '@Pages/documentation/medical-certificate';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          index: true,
          element: <Navigate to={PATHS.PROFILE} replace />,
        },
        {
          path: PATHS.PROFILE,
          element: <ProfilePage />,
        },
        {
          path: PATHS.SCHEDULING,
          element: <SchedulingPage />,
        },
        {
          path: PATHS.DOCUMENTATION,
          children: [
            { path: '', element: <DocumentationPage /> },
            { path: PATHS.PASSPORT, element: <PassportPage /> },
            { path: PATHS.VISA, element: <VisaPage /> },
            { path: PATHS.PICKUP, element: <PickupPage /> },
            { path: PATHS.WORK_PERMIT, element: <WorkPermitPage /> },
            { path: PATHS.MEDICAL_CERTIFICATE, element: <MedicalCertificatePage /> },
          ],
        },
      ],
    },
  ],
  {
    basename: import.meta.env.VITE_ROUTER_BASENAME,
  }
);
